import { Routes } from '@angular/router';
import { BomListPage } from './components/pages/bom-list/bom-list.page';
import { BomTreePage } from './components/pages/bom-tree/bom-tree.page';
import { BomImportPage } from './components/pages/bom-import/bom-import.page';
import { OrdersBoardPage } from './components/pages/orders-board/orders-board.page';
import { ProductionPlannerPage } from './components/pages/production-planner/production-planner.page';
import { OrdersNewPage } from './components/pages/orders-new/orders-new.page';
import { ProductionOverseerPage } from './components/pages/production-overseer/production-overseer.page';
import { ClientOrdersPage } from './components/pages/client-orders/client-orders.page';
import { ClientOrderPage } from './components/pages/client-order/client-order.page';
import { ShipmentsPage } from './components/pages/shipments/shipments.page';
import { ShipmentPage } from './components/pages/shipment/shipment.page';
import { SignInPage } from './components/pages/sign-in/sign-in.page';
import { SetPasswordPage } from './components/pages/set-password/set-password.page';
import { SettingsUsersPage } from './components/pages/settings-users/settings-users.page';
import { ReportsPage } from './components/pages/reports/reports.page';
import { MaterialRequirementsPage } from './components/pages/material-requirements/material-requirements.page';
import { DocumentsPage } from './components/pages/documents/documents.page';
import { homeRedirect, permissionGuard, sessionGuard, signedOutGuard } from './services/session.guard';

// Every route but /sign-in and /set-password needs a session (sessionGuard); /sign-in needs the opposite,
// and /set-password works either way: the link is the credential, and setting the password replaces any session (0057)
export const routes: Routes = [
  {
    path: '',
    redirectTo: homeRedirect,
    pathMatch: 'full'
  },
  {
    path: 'sign-in',
    component: SignInPage,
    canActivate: [signedOutGuard]
  },
  {
    path: 'set-password',
    component: SetPasswordPage
  },
  {
    path: 'bom',
    component: BomListPage,
    canActivate: [sessionGuard]
  },
  // before bom/:id so the literal wins over the id route (0070)
  {
    path: 'bom/import',
    component: BomImportPage,
    canActivate: [sessionGuard, permissionGuard('BomWrite')]
  },
  {
    path: 'bom/:id',
    component: BomTreePage,
    canActivate: [sessionGuard]
  },
  {
    path: 'orders',
    component: OrdersBoardPage,
    canActivate: [sessionGuard]
  },
  {
    path: 'orders/:id',
    component: OrdersNewPage,
    canActivate: [sessionGuard]
  },
  {
    path: 'client-orders',
    component: ClientOrdersPage,
    canActivate: [sessionGuard]
  },
  {
    path: 'client-orders/:id',
    component: ClientOrderPage,
    canActivate: [sessionGuard]
  },
  {
    path: 'shipments',
    component: ShipmentsPage,
    canActivate: [sessionGuard]
  },
  {
    path: 'shipments/:id',
    component: ShipmentPage,
    canActivate: [sessionGuard]
  },
  {
    path: 'planner',
    component: ProductionPlannerPage,
    canActivate: [sessionGuard]
  },
  {
    path: 'production',
    component: ProductionOverseerPage,
    canActivate: [sessionGuard]
  },
  // no permission guard: the API's Read is the rule, a Brygadzista reads documentation like everything else (0125)
  {
    path: 'documents',
    component: DocumentsPage,
    canActivate: [sessionGuard]
  },
  // no permission guard: the API's Read is the rule, a Brygadzista reads the log like everything else (0105)
  {
    path: 'reports',
    component: ReportsPage,
    canActivate: [sessionGuard]
  },
  // the second Raporty tab (0118); /reports stays the log so every existing link keeps working
  {
    path: 'reports/materials',
    component: MaterialRequirementsPage,
    canActivate: [sessionGuard]
  },
  {
    path: 'settings/users',
    component: SettingsUsersPage,
    canActivate: [sessionGuard, permissionGuard('UsersManage')]
  }
];
